import { PageHeader } from '@cast/design-system';

export const WorkloadsPageHeader = () => <PageHeader heading="Workloads" />;
